import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, redirect } from 'react-router-dom';

import Menu from "./components/menu/menu.jsx";
import Login from "./pages/login/login.jsx";

import Dashboard from "./pages/dashboard/dashboard.jsx";
import NFeEntrada from "./pages/portal/nfeentrada/NFeEntrada.jsx";
import ListaNFeSaida from "./pages/portal/nfesaida/listaNFeSaida.jsx";
import ListaNFSe from "./pages/portal/nfse/listaNFSe.jsx";
import ListaCTe from "./pages/portal/cte/listaCTe.jsx";
import ListaNFCe from "./pages/portal/nfce/listaNFCe.jsx";
import Fechamento from "./pages/portal/fechamento/fechamento.jsx";

import Entidade from "./pages/faturamento/cadastro/entidade/listaEntidade.jsx";
import Produto from "./pages/faturamento/cadastro/produto/listaProduto.jsx";
import NCM from "./pages/faturamento/cadastro/ncm/listaNCM.jsx";
import CFOP from "./pages/faturamento/cadastro/cfop/listaCFOP.jsx";
// import Artigo from "./pages/faturamento/cadastro/artigo/listaArtigo.jsx";
// import FaturamentoMensal from "./pages/faturamento/cadastro/faturamentomensal/listaFaturamentoMensal.jsx";

import CrudEmpresa from './pages/configuracoes/empresa/crudEmpresa.jsx';
import CrudCertificado from './pages/configuracoes/certificado/crudCertificado.jsx';
import ListaUsuario from './pages/configuracoes/usuario/listaUsuario.jsx';
import CrudUsuario from './pages/configuracoes/usuario/crudUsuario.jsx';

import { AuthContext } from "./contexts/AuthContext.js";
import Header from './components/header/header.js';
import Footer from './components/footer/footer.js';
import Container from './components/container/container.js';
import ModalTrocarEmpresas from './components/modal/trocarEmpresa.jsx';
import EsqueciSenha from './pages/login/esqueciSenha.jsx';
import CriarSenha from './pages/login/criarSenha.jsx';


function Rotas() {

    const { logado } = useContext(AuthContext);

    // function SecureRoute({...params}){
    //         if(!logado){
    //             return redirect('/');
    //         } else {
    //              return <Route {...params}/>
    //         }
    // };

    return <BrowserRouter>

        { (window.location.pathname !=='/') && 
           (window.location.pathname !=='/login') &&
           (window.location.pathname !=='/esqueciSenha') &&
           (window.location.pathname.substring(0,11) !=='/criarSenha') ? <Header />:null}
        
        <Container>
            <Routes>
                {/* <Switch> */}
                {/* Portal */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/login" element={<Login />} />
                <Route path="/esqueciSenha" element={<EsqueciSenha />} />
                <Route path="/criarSenha/:id" element={<CriarSenha />} />

                <Route path="/" element={<Login />} />
                <Route path="/nfeentrada" element={<NFeEntrada />} />
                <Route path="/nfesaida" element={<ListaNFeSaida />} />
                <Route path="/cte" element={<ListaCTe />} />
                <Route path="/nfce" element={<ListaNFCe />} />
                <Route path="/nfse" element={<ListaNFSe />} />
                <Route path="/fechamento" element={<Fechamento />} />

                {/* Faturamento */}
                <Route path="/cliente" element={<Entidade />} />
                <Route path="/fornecedor" element={<Entidade />} />
                <Route path="/transportadora" element={<Entidade />} />
                <Route path="/produto" element={<Produto />} />
                <Route path="/ncm" element={<NCM />} />
                <Route path="/cfop" element={<CFOP />} />
                {/* <Route path="/artigo" element={ <Artigo/>} />
                   <Route path="/faturamentomensal" element={ <FaturamentoMensal/>} /> */}

                {/* Configurações */}
                <Route path="/trocar" element={<ModalTrocarEmpresas />} />

                <Route path="/empresa" element={<CrudEmpresa />} />
                <Route path="/certificado" element={<CrudCertificado />} />
                <Route path="/usuario" element={<ListaUsuario />} />
                <Route path="/crudUsuario/:id" element={<CrudUsuario />} />

                {/* </Switch> */}
            </Routes>
        </Container>
        <Footer />
    </BrowserRouter>
};

export default Rotas;


// aws Configure
// Chave de acesso: AKIAVTRZ3G45NCMZPJNP
// Chave de acesso secreta: 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



